<template>
	<div>
		<v-app-bar id="default-app-bar" app absolute class="v-bar--underline" :class="{ 'demo': !purchased }" color="transparent" :clipped-left="$vuetify.rtl" :clipped-right="!$vuetify.rtl" height="70" flat>
			<demo-bar />

			<v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />

			<default-settings />

			<v-spacer />

			<today class="ml-5" />

			<default-search />

			<default-notifications />

			<default-account @profile="profile" @settings="settings" @apiSettings="apiSettings" @thirdParty="thirdParty" />

			<v-dialog v-model="dialogUser" scrollable persistent max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات کاربر</span>
						<v-spacer />
						<v-btn @click="dialogUser = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-user ref="modifyUser" :data="selectedUser" @callbck="callbck_userprofile" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogSettings" scrollable persistent max-width="800px">
				<v-card>
					<v-card-title>
						<span class="headline">تنظیمات سیستم</span>
						<v-spacer />
						<v-btn @click="dialogSettings = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<app-settings ref="appSettings" @callbck="callbck_settings" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogApiSettings" scrollable persistent max-width="500px">
				<v-card>
					<v-card-title>
						<span class="headline">تنظیمات رابط API</span>
						<v-spacer />
						<v-btn @click="dialogApiSettings = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<api-settings ref="api" v-if="dialogApiSettings" @callbck="callbck_apiSettings" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogThirdParty" scrollable persistent>
				<v-card>
					<v-card-title>
						<span class="headline">ارتباط با دیگر نرم افزارها</span>
						<v-spacer />
						<v-btn @click="dialogThirdParty = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<thirdParty v-if="dialogThirdParty" @callbck="callbck_thirdParty" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>


		</v-app-bar>
	</div>
</template>

<script>
	// Utilities
	import { get, sync } from 'vuex-pathify'
	import ModifyUser from '@/views/admin/ModifyUser.vue'
	import AppSettings from '@/views/admin/AppSettings.vue'
	import ApiSettings from '@/components/forms/ApiSettings.vue'
	import ThirdParty from '@/views/admin/ThirdParty.vue'

	export default {
		name: 'DefaultBar',

		components: {
			DemoBar: () => import(
				/* webpackChunkName: "default-account" */
				'../../views/DemoBar.vue'
			),
			DefaultAccount: () => import(
				/* webpackChunkName: "default-account" */
				'./widgets/Account'
			),
			DefaultDrawerToggle: () => import(
				/* webpackChunkName: "default-drawer-toggle" */
				'./widgets/DrawerToggle'
			),
			DefaultNotifications: () => import(
				/* webpackChunkName: "default-notifications" */
				'./widgets/Notifications'
			),
			DefaultSearch: () => import(
				/* webpackChunkName: "default-search" */
				'./widgets/Search'
			),
			DefaultSettings: () => import(
				/* webpackChunkName: "default-settings" */
				'./Settings'
			),
			Today: () => import(
				/* webpackChunkName: "default-settings" */
				'./widgets/Today'
			),

			'modify-user': ModifyUser,
			'app-settings': AppSettings,
			'api-settings': ApiSettings,
			'thirdParty': ThirdParty
		},
		data() {
			return {
				selectedUser: {},
				dialogUser: false,
				dialogSettings: false,
				dialogApiSettings: false,
				dialogThirdParty: false
			}
		},
		computed: {
			...sync('app', [
				'drawer',
				'mini',
			]),
			name: get('route/name'),
			getCurrentUser: get('auth/getCurrentUser'),
			purchased() {
				return this.getCurrentUser?.userData?.customer?.purchased
			},
		},
		methods: {
			profile() {
				var user = this.getCurrentUser
				if (!user || !user.userData) { return }
				this.selectedUser = { id: user.userData.id }
				this.dialogUser = true
				this.$nextTick(() => {
					this.$refs.modifyUser.prepareData()
				})
			},
			settings() {
				this.dialogSettings = true
			},
			apiSettings() {
				this.dialogApiSettings = true
			},
			thirdParty() {
				this.dialogThirdParty = true
			},
			callbck_userprofile(result) {
				this.dialogUser = false
			},
			callbck_settings(result) {
				this.dialogSettings = false
			},
			callbck_apiSettings(result) {
				this.dialogApiSettings = false
			},
			callbck_thirdParty() {
				this.dialogThirdParty = false
			}
		},
	}
</script>

<style lang="sass">
#default-app-bar
	.v-toolbar__content
		flex-wrap: wrap
</style>
